// Короткое сообщение внизу экрана (лимит избранного, сбой). Один на приложение.
import { useEffect, useState } from 'react';
import styles from './Toast.module.css';

let push: ((text: string) => void) | null = null;
export function toast(text: string): void { push?.(text); }

export function ToastHost() {
  const [text, setText] = useState<string | null>(null);
  useEffect(() => {
    push = (next) => setText(next);
    return () => { push = null; };
  }, []);
  useEffect(() => {
    if (!text) return;
    const timer = setTimeout(() => setText(null), 3500);
    return () => clearTimeout(timer);
  }, [text]);
  return text ? <div className={styles.toast} role="status">{text}</div> : null;
}
